/**
 * Lightweight hash utilities for data comparison
 * Avoids expensive JSON.stringify operations by using fast string concatenation
 */

/**
 * Creates a lightweight hash for editableData array comparison
 * Uses key fields (length, first/last declaration identifiers) for fast change detection
 * @param {Array|Object} data - EditableData array or single declaration object
 * @returns {string} Hash string for comparison
 */
export const createEditableDataHash = (data) => {
  if (!data || (Array.isArray(data) && data.length === 0)) return '';
  const arr = Array.isArray(data) ? data : [data];
  const firstDecl = arr[0];
  const lastDecl = arr[arr.length - 1];
  return `${arr.length}_${firstDecl?.expediente || ''}_${firstDecl?.tipo || ''}_${lastDecl?.expediente || ''}`;
};

/**
 * Creates a lightweight hash for validation errors array comparison
 * Uses error counts per declaration and field IDs for fast change detection
 * @param {Array|null} errors - Validation errors array or null
 * @returns {string} Hash string for comparison
 */
export const createValidationErrorsHash = (errors) => {
  if (!errors || errors.length === 0) return 'empty';
  let hash = '';
  for (const decl of errors) {
    hash += `${decl.declarationNumber}_`;
    hash += `${decl.declarationErrors?.length || 0}_`;
    // Include field IDs for declaration errors to detect specific field changes
    if (decl.declarationErrors?.length) {
      hash += decl.declarationErrors.map(e => e.field).sort().join(',') + '_';
    }
    hash += `${decl.itemErrors?.length || 0}_`;
    hash += `${decl.documentErrors?.length || 0}_`;
    hash += `${decl.packageErrors?.length || 0}_`;
  }
  return hash;
};

